import { useCallback, useMemo } from 'react';
import * as ROLES from '../constants/roles';
import { useAuthContext } from '../pages/Posts/useAuthContext';

export const useAuth = () => {
    const currentUser = useAuthContext();

    const isAdmin = !!currentUser && currentUser.role === ROLES.ADMIN;

    return {
        currentUser: currentUser ? currentUser : {},
        isGuest: !currentUser,
        isAdmin,
    };
};
